module.exports = __webpack_public_path__ + "media/parents/college-financial-planning-fc66bdf0.svg";